// extracted by mini-css-extract-plugin
export default {"wrapper":"SectionTitle_wrapper__hmVwb","hasSubTitle":"SectionTitle_hasSubTitle__l67L5","hasMarginBottom":"SectionTitle_hasMarginBottom__whcGm"};